import React, { useContext, useEffect, useState, useRef } from 'react';
import { withRouter, useHistory } from 'react-router-dom';

import { MerchantProfileContext } from 'src/context/merchant-profile-context';
import {
  businessCashAdvanceDashboardRoute,
  businessCashAdvanceNoQualifyRoute,
  businessCashAdvancePreApprovedRoute,
  businessCashAdvanceTopUpCalculationRoute,
} from 'src/routing/routes';
import { OfferContext } from 'src/context/offer-context';
import TealiumEvents from 'src/helpers/tealium-events';
import HeaderNav from '../../header-nav/header-nav';
import MiniAppEvents from 'src/helpers/miniapp-events';
import { Button } from '@vfs-digital-channels/ns-react-components';
import { FallingBags, HandCash } from 'src/assets/images';
import { applyForFundingURL, fundMyNextReadMoreUrl, moreInfoForFundingURL } from 'src/common';

import './get-financed.scss';

const BCAGetFinanced = () => {
  const inMiniProgram = MiniAppEvents.isInMiniApp();
  const { merchant } = useContext(MerchantProfileContext);
  const { offers, isBCATopUp } = useContext(OfferContext);
  const [isPreApproved, setIsPreApproved] = useState(false);
  const [, setIsActive] = useState(false);
  const topOfPage = useRef('top');

  const history = useHistory();

  useEffect(() => {
    TealiumEvents.getFinancedPageLoadNewStyle();

    if (topOfPage.current) {
      topOfPage.current.scrollIntoView(false);
    }
  }, []);

  useEffect(() => {
    if (offers?.offerDetails?.CurrentBalance > 0) {
      setIsActive(true);
    } else if (offers?.offerDetails?.QualificationStatus === 1) {
      setIsPreApproved(true);
    }
  }, [offers]);

  return (
    <div className="BCAGetFinanced" data-testid="BCAGetFinanced">
      <HeaderNav
        title={merchant?.companyName ? `Hi, welcome back ${merchant?.companyName}` : ''}
        screenName="Get Financed"
      >
        <h1 className="page-title" ref={topOfPage}>
          Finance options
        </h1>
        <div className="page-description">
          Whether you need to fund moving into a bigger office, buy equipment or property or just to
          get the cash flow you need to act quickly, we can make it happen.
        </div>
        <div className="flex flex-wrap gap-4">
          <article className="flex w-full h-full px-4 max-w-143 md:max-h-78 md:p-3">
            <img
              className="w-full rounded-l-4 max-w-38 md:max-w-none"
              src={FallingBags}
              alt="Falling bags"
            />
            <section className="flex flex-col gap-4 py-4 pl-8 pr-4 bg-grey-900 rounded-4">
              <h3 className="text-2xl font-medium text-white">Fund your business</h3>
              <p className="text-sm font-bold text-grey-300 min-h-10">
                Finance options - 3 to 12 months
              </p>
              <p className="text-sm text-grey-300 ">
                If your South African business makes R500,000 or more a year and has operated for at
                least 12 months...
              </p>
              {!inMiniProgram && (
                <a
                  className="is-red-text-link"
                  href={moreInfoForFundingURL}
                  onClick={() => TealiumEvents.getFinancedFundMeMoreInfo(moreInfoForFundingURL)}
                  target="_blank"
                  automationid="BCA_Link_GetFinancedFundMoreInfo"
                  rel="noreferrer"
                >
                  More info...
                </a>
              )}
              {!inMiniProgram && (
                <Button className="mt-auto" asChild>
                  <a
                    automationid="BCA_Link_GetFinancedFundMoreInfo"
                    className="view-more"
                    href={applyForFundingURL}
                    onClick={() => TealiumEvents.getFinancedClickBTAApplyNow(applyForFundingURL)}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Apply now
                  </a>
                </Button>
              )}
            </section>
          </article>

          <article className="flex w-full h-full px-4 max-w-143 md:max-h-78 md:p-3">
            {isPreApproved && (
              <p className="absolute p-1 text-xs bg-red-600 rounded-tl-4 rounded-br-4">
                Pre-approved
              </p>
            )}

            <img
              className="w-full rounded-l-4 max-w-38 md:max-w-none"
              src={HandCash}
              alt="hand cash"
            />
            <section className="flex flex-col gap-4 py-4 pl-8 pr-4 bg-grey-900 rounded-4">
              <h3 className="text-2xl font-medium text-white">Business Cash Advance</h3>
              <p className="text-sm font-bold text-grey-300">
                Flexible repayments using your VodaPay card machine
              </p>
              <p className="text-sm text-grey-300 ">
                This is the ideal solution for a registered business that makes at least R3000 per
                month...
              </p>
              {!inMiniProgram && (
                <a
                  className="is-red-text-link"
                  href={fundMyNextReadMoreUrl}
                  onClick={() => TealiumEvents.getFinancedFundMeMoreInfo(moreInfoForFundingURL)}
                  target="_blank"
                  automationid="Payment_Services_Dashboard_Link_Fund_My_Next_Move_More_Info"
                  rel="noreferrer"
                >
                  More info...
                </a>
              )}

              {isPreApproved ? (
                <Button
                  onClick={() => {
                    TealiumEvents.getFinancedClickBCAApplyNow(businessCashAdvancePreApprovedRoute);
                    history.push(
                      isBCATopUp
                        ? businessCashAdvanceTopUpCalculationRoute
                        : businessCashAdvanceDashboardRoute,
                    );
                  }}
                >
                  Apply now
                </Button>
              ) : (
                <Button
                  onClick={() => {
                    TealiumEvents.getFinancedClickBCAApplyNow(businessCashAdvanceNoQualifyRoute);
                    history.push(
                      isBCATopUp
                        ? businessCashAdvanceTopUpCalculationRoute
                        : businessCashAdvanceDashboardRoute,
                    );
                  }}
                >
                  Apply now
                </Button>
              )}
            </section>
          </article>
        </div>
      </HeaderNav>
    </div>
  );
};

BCAGetFinanced.propTypes = {};

BCAGetFinanced.defaultProps = {};

export default withRouter(BCAGetFinanced);
